import { render, staticRenderFns } from "./DeveloperInterviewArticleComments.vue?vue&type=template&id=c6129e7a&scoped=true"
import script from "./DeveloperInterviewArticleComments.vue?vue&type=script&lang=js"
export * from "./DeveloperInterviewArticleComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6129e7a",
  null
  
)

export default component.exports